import React, { useState } from 'react';

import { Icon } from 'antd';
import { Popover } from '@blueprintjs/core';
import { ActionMenu, ActionMenuItem } from 'common-components/action-menu';

interface DayColumnProps {
  content: React.ReactNode;
  hasAddAction?: boolean;
}

export function DayColumn({ content, hasAddAction = false }: DayColumnProps) {
  const [isHovered, setIsHovered] = useState(false);
  const [isDialogOpen, setIsDialogOpen] = useState(false);

  const onOpen = () => setIsDialogOpen(true);
  const onClose = () => setIsDialogOpen(false);

  return (
    <div
      style={{ minHeight: '100%' }}
      className='position-relative'
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {hasAddAction && (isHovered || isDialogOpen) && (
        <div className='position-absolute' style={{ bottom: 4, right: 4 }}>
          <Popover
            content={
              <ActionMenu>
                <ActionMenuItem text={'Add new booking...'} />
              </ActionMenu>
            }
            position={'bottom-right'}
            usePortal={false}
            targetTagName={'span'}
            onOpening={onOpen}
            onClose={onClose}
          >
            <div
              className='p-x-small rounded bordered border-blue-action flex-row align-center justify-center cursor-pointer'
              style={{ width: '24px', height: '24px' }}
            >
              <Icon type='plus' style={{ fontSize: '13px' }} className='text-color-blue-action' />
            </div>
          </Popover>
        </div>
      )}
      {content}
    </div>
  );
}
